import React, { useState } from "react";
import { Button, Form, Input, Modal, message } from "antd";
import { Phone, Calendar, X } from "lucide-react";
import "./FloatingButtons.css";
import axios from "axios";

const FloatingButtons = () => {
  const [callbackVisible, setCallbackVisible] = useState(false);
  const [siteVisitVisible, setSiteVisitVisible] = useState(false);
  const [callbackForm] = Form.useForm();
  const [siteVisitForm] = Form.useForm();
  const [callbackLoading, setCallbackLoading] = useState(false);
  const [siteVisitLoading, setSiteVisitLoading] = useState(false);

  // Function to handle callback form submission
  const handleCallbackSubmit = async (values) => {
    setCallbackLoading(true);
    try {
      // Use the same API endpoint as your contact form
      const response = await axios.post("/api/v1/leads", {
        ...values,
        type: "callback",
      });

      message.success("Thank you! We'll call you back shortly.");
      callbackForm.resetFields();
      setCallbackVisible(false);
    } catch (error) {
      message.error("Something went wrong. Please try again later.");
      console.error("Error submitting callback form:", error);
    } finally {
      setCallbackLoading(false);
    }
  };

  // Function to handle site visit form submission
  const handleSiteVisitSubmit = async (values) => {
    setSiteVisitLoading(true);
    try {
      // Use the same API endpoint as your contact form
      const response = await axios.post("/api/v1/leads", {
        ...values,
        type: "site_visit",
      });

      message.success("Thank you! Your site visit has been scheduled.");
      siteVisitForm.resetFields();
      setSiteVisitVisible(false);
    } catch (error) {
      message.error("Something went wrong. Please try again later.");
      console.error("Error submitting site visit form:", error);
    } finally {
      setSiteVisitLoading(false);
    }
  };

  return (
    <div className="floating-buttons-container">
      {/* Callback Button */}
      <div
        className="floating-button callback-button"
        onClick={() => setCallbackVisible(true)}
      >
        <div className="floating-button-content">
          <Phone size={24} />
          <span className="button-text">Get a Callback</span>
        </div>
      </div>

      {/* Site Visit Button */}
      <div
        className="floating-button site-visit-button"
        onClick={() => setSiteVisitVisible(true)}
      >
        <div className="floating-button-content">
          <Calendar size={24} />
          <span className="button-text">Schedule Visit</span>
        </div>
      </div>

      {/* Callback Modal */}
      <Modal
        title="Request a Callback"
        open={callbackVisible}
        onCancel={() => setCallbackVisible(false)}
        footer={null}
        className="form-modal"
        closeIcon={<X size={18} />}
      >
        <p className="modal-description">
          Fill in your details and our team will call you back shortly.
        </p>
        <Form
          form={callbackForm}
          layout="vertical"
          onFinish={handleCallbackSubmit}
          requiredMark={false}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your name" size="large" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" size="large" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              { required: true, message: "Please enter your phone number" },
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number",
              },
            ]}
          >
            <Input placeholder="Enter your phone number" size="large" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={callbackLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Site Visit Modal */}
      <Modal
        title="Schedule a Site Visit"
        open={siteVisitVisible}
        onCancel={() => setSiteVisitVisible(false)}
        footer={null}
        className="form-modal"
        closeIcon={<X size={18} />}
      >
        <p className="modal-description">
          Schedule a visit to our property and experience it firsthand.
        </p>
        <Form
          form={siteVisitForm}
          layout="vertical"
          onFinish={handleSiteVisitSubmit}
          requiredMark={false}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Enter your name" size="large" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input placeholder="Enter your email" size="large" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              { required: true, message: "Please enter your phone number" },
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number",
              },
            ]}
          >
            <Input placeholder="Enter your phone number" size="large" />
          </Form.Item>

          <Form.Item
            name="preferred_date"
            label="Preferred Date & Time (Optional) Site visits only on Wednesday's & Sunday's"
          >
            <Input placeholder="e.g., Weekend, Next Week" size="large" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={siteVisitLoading}
            >
              Schedule Visit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default FloatingButtons;
